import { Button } from '@savvy-kit/components/button/button';
import { Text } from '@savvy-kit/foundations/text';
import { cn } from '@savvy-kit/lib/utils';
import { PaperclipIcon } from 'lucide-react';

import { useFileAttachmentContext } from './with-file-upload';

export type AttachFileButtonProps = {
  onClick?: () => void;
  className?: string;
};

export function AttachFileButton({ onClick, className }: AttachFileButtonProps) {
  const ctx = useFileAttachmentContext();
  const handleClick = onClick ?? ctx?.openFilePicker;
  const fileCount = ctx?.files.length ?? 0;
  const isDisabled = ctx?.disabled ?? false;

  return (
    <Button
      variant="secondary"
      type="button"
      disabled={isDisabled}
      onClick={handleClick}
      icon={<PaperclipIcon className="size-4" />}
      className={className}
    >
      Attach file
      {fileCount > 0 && (
        <Text
          variant="caption"
          className={cn('ml-1 rounded-full bg-slate-100 px-2 py-0.5 font-semibold text-slate-600')}
        >
          {fileCount}
        </Text>
      )}
    </Button>
  );
}
